<template>
    <div>
        <WebDataRocks
            :key="key"
            ref="myPivot"
            :report="pivotConfig"
            :global="pivotGlobal"
            toolbar
        />
    </div>
</template>

<script>
import webDataRocksFrLocalization from '../../../../../../lang/fr/webDataRocksFrLocalization.json'
import WebDataRocks from '../../../common/components/WebDataRocks.vue'

export default {
    name: 'PivotReport',

    components: {
        WebDataRocks,
    },

    props: {
        clientId: 0,
        year: 0,
        reportUnit: '',
    },

    data() {
        return {
            key: 'wdr',
            pivotConfig: {
                dataSource: {
                    dataSourceType: 'json',
                    filename: `${
                        document.head.querySelector('meta[name="api-base-url"]')
                            .content
                    }time-sheets/reporting/pivot/${this.clientId}/${this.year}`,
                },
                slice: {
                    rows: [
                        {
                            uniqueName: 'categorie',
                            sort: 'asc',
                        },
                        {
                            uniqueName: 'affectation',
                        },
                        {
                            uniqueName: 'initiales',
                        },
                    ],
                    columns: [
                        {
                            uniqueName: 'date.Month',
                        },
                    ],
                    measures: [
                        {
                            uniqueName: 'duree',
                            aggregation: 'sum',
                            format: 'durationFormat',
                        },
                    ],
                    expands: {
                        expandAll: false,
                    },
                    drills: {
                        drillAll: false,
                    },
                },
                options: {
                    grid: {
                        type: 'compact',
                        title: '',
                        showFilter: true,
                        showHeaders: false,
                        showTotals: true,
                        showGrandTotals: 'on',
                        showHierarchies: true,
                        showHierarchyCaptions: true,
                        showReportFiltersArea: true,
                    },
                    configuratorActive: false,
                    configuratorButton: true,
                    showAggregations: true,
                    showCalculatedValuesButton: true,
                    drillThrough: true,
                    showDrillThroughConfigurator: true,
                    sorting: 'on',
                    datePattern: 'yyyy-MM-dd',
                    dateTimePattern: 'dd/MM/yyyy HH:mm:ss',
                    saveAllFormats: false,
                    showDefaultSlice: true,
                    defaultHierarchySortName: 'asc',
                },
                formats: [
                    {
                        name: 'amountFormat',
                        thousandsSeparator: ' ',
                        decimalSeparator: '.',
                        decimalPlaces: 2,
                        maxSymbols: 20,
                        currencySymbol: '€',
                        currencySymbolAlign: 'right',
                        nullValue: ' ',
                        infinityValue: 'Infinity',
                        divideByZeroValue: 'Infinity',
                    },
                    {
                        name: 'durationFormat',
                        thousandsSeparator: ' ',
                        decimalSeparator: '.',
                        decimalPlaces: 1,
                        maxSymbols: 20,
                        currencySymbol: '',
                        currencySymbolAlign: 'right',
                        nullValue: ' ',
                        infinityValue: 'Infinity',
                        divideByZeroValue: 'Infinity',
                    },
                ],
            },

            pivotGlobal: {
                localization: webDataRocksFrLocalization,
            },

            pivotData: [],
        }
    },

    created() {
        this.init()
    },

    methods: {
        init() {
            if (this.reportUnit === 'hours') {
                this.setDuration()
            } else {
                this.setAmount()
            }
        },

        setDuration() {
            this.pivotConfig.slice.measures = [
                {
                    uniqueName: 'duree',
                    aggregation: 'sum',
                    format: 'durationFormat',
                },
            ]
            this.key = Date.now()
        },

        setAmount() {
            this.pivotConfig.slice.measures = [
                {
                    uniqueName: 'montant',
                    aggregation: 'sum',
                    format: 'amountFormat',
                },
            ]
            this.key = Date.now()
        },
    },
}
</script>

<style scoped></style>
